module.exports = __webpack_public_path__ + "static/pB2-008e2589011c2ec1dc32dfd09b98f25d.png";